import { useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { RiArrowLeftRightLine } from 'react-icons/ri';
import { SubButton } from 'src/components/button/SubButton';
import { RoleNavbar } from 'src/layouts/dashboard/navbar/Navbar';
import { PATH_APP } from 'src/routes/paths';
import { useOrganization } from 'src/contexts/OrganizationContext';

type Props = {
  role: RoleNavbar;
  setRole: React.Dispatch<React.SetStateAction<RoleNavbar>>;
};
// adminの場合はメンバーメニューに、メンバーの場合はadminメニューに切り替えるボタン
export const ToggleRoleButton = ({ role, setRole }: Props): ReactElement => {
  const { currentUser, organization, isLoading } = useOrganization();
  const theme = useTheme();
  const router = useRouter();

  // ローディング中またはデータがない場合は何も表示しない
  if (isLoading || !currentUser || !organization) {
    return <></>;
  }

  // adminの場合はメンバーメニューに、メンバーの場合はadminメニューに切り替えるボタン
  if (!currentUser.admin) {
    return <></>;
  }
  if (role === 'admin') {
    return (
      <SubButton
        startIcon={<RiArrowLeftRightLine />}
        onClick={() => {
          setRole('member');
          router.push({
            pathname: PATH_APP.me.root,
            query: { organizationName: organization.name },
          });
        }}
        sx={{
          color: theme.palette.text.contrast,
          fontSize: '12px',
          width: '100%',
          boxSizing: 'border-box',
          height: '42px',
          borderColor: theme.palette.border.primary,
          ':hover': { backgroundColor: theme.palette.primary.light },
        }}
      >
        メンバーメニューへ
      </SubButton>
    );
  }

  // roleがmemberの場合
  return (
    <SubButton
      startIcon={<RiArrowLeftRightLine />}
      sx={{ fontSize: '12px', width: '100%', height: '42px' }}
      onClick={() => {
        setRole('admin');
        router.push({
          pathname: PATH_APP.admin.setting.root,
          query: { organizationName: organization.name },
        });
      }}
    >
      管理者メニューへ
    </SubButton>
  );
};
